import { Circle, Defs, LinearGradient, Path, Rect, Stop, Svg } from "@-/com.npmjs.react-native-svg";
import { useId } from "react";

const RIM = "#8F4908";
/** `useId` may contain characters an SVG `url(#…)` reference cannot. */
const NON_ID_CHARACTER = /[^\w-]/;
/** Outer disk minus the square hole (even-odd), so the hole shows whatever is behind the coin. */
const DISK_WITH_HOLE = "M16 0.5A15.5 15.5 0 1 1 15.99 0.5ZM12.2 12.2V19.8H19.8V12.2Z";
const FACE_WITH_HOLE = "M16 2.3A13.7 13.7 0 1 1 15.99 2.3ZM12.2 12.2V19.8H19.8V12.2Z";

/**
 * A gold Chinese cash coin (方孔钱) for the deposit animation: a beveled disk with a real square
 * hole and a glint along its upper edge. Drawn to be looked at while it flies. Static UI uses the
 * flat gold `HanCashCoin` icon instead.
 */
export function HanCoinGlyph({ size }: { size: number }) {
  // Gradient ids are global in a web document, so every coin needs its own.
  const faceId = `han-coin-face-${useId().split(NON_ID_CHARACTER).join("")}`;
  return (
    <Svg height={size} viewBox="0 0 32 32" width={size}>
      <Defs>
        <LinearGradient id={faceId} x1="0.15" x2="0.85" y1="0.05" y2="0.95">
          <Stop offset="0" stopColor="#FFE0A3" />
          <Stop offset="0.38" stopColor="#F5A623" />
          <Stop offset="0.75" stopColor="#DF850B" />
          <Stop offset="1" stopColor="#A95A08" />
        </LinearGradient>
      </Defs>
      <Path d={DISK_WITH_HOLE} fill={RIM} fillRule="evenodd" />
      <Path d={FACE_WITH_HOLE} fill={`url(#${faceId})`} fillRule="evenodd" />
      <Circle cx={16} cy={16} fill="none" opacity={0.55} r={11.2} stroke={RIM} strokeWidth={0.8} />
      <Rect fill="none" height={8.8} stroke={RIM} strokeWidth={1.4} width={8.8} x={11.6} y={11.6} />
      <Path
        d="M7.2 10.4A10.2 10.2 0 0 1 14.6 5.6"
        fill="none"
        opacity={0.9}
        stroke="#FFF3DF"
        strokeLinecap="round"
        strokeWidth={1.6}
      />
    </Svg>
  );
}
